const isFirstPartyFrame = (frame) => {
  if (!frame) return false
  if (frame.inProject === true || frame.in_project === true) return true
  if (typeof frame.file !== 'string') return false
  if (frame.file.startsWith('webpack://')) return true
  if (/^https?:\/\/([^/]*\.)?mtggoldfish\.com\/(assets|packs|javascripts)\//.test(frame.file)) return true
  if (/^https?:\/\/([^/]*\.)?mtggoldfish\.com\/.*\.js(\?|#|$)/.test(frame.file)) return true
  return false
}

const THIRD_PARTY_PATTERNS = [
  /Throttled is not defined|can't find variable: Throttled/i,
  // NOTE: "$ is not defined" removed — ad-blockers or broken third-party scripts
  // can shadow globals; keeping this unfiltered avoids masking first-party errors.
  // NOTE: "Image is not a constructor" removed — we use new Image() in visual_deck.js and
  // CardGraph.js; an ad script redefining Image could cause this to fire from our code.
  /track is not defined|can't find variable: track/i,
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i,
  /window\.__gpp is not a function/,
  /\.refreshUserIds is not a function/,
  /NS_ERROR_(UNEXPECTED|NOT_INITIALIZED|FAILURE)/,
  /this\._global\[this\._globalBindingName\] is not a function/,
  /unhandledrejection handler received a non-error/i,
  /Loading chunk \d+ failed.*(?:vntsm|venatusmedia)\.com/i,
  /Failed to execute 'appendChild' on 'Node': Unexpected identifier 'disallow'/,
  /Failed to execute 'replaceWith' on 'Element': Unexpected identifier/,
  /^Request aborted$/,
]

const AD_NETWORK_DOMAINS = /\b(venatusmedia\.com|vntsm\.com|cpx\.to|cadmus\.script\.ac|hb\.vntsm\.com)\b/

export { isFirstPartyFrame, THIRD_PARTY_PATTERNS, AD_NETWORK_DOMAINS }
